import message from 'antd/lib/message';

import * as ApikoApi from '../../api/apiko-api';
import * as actions from '../actions/organization-settings';

import { getResErrorMsg } from '../../utils';

/**
 * handleOrganizationSettingsFetch :: _ -> Func -> Promise Error [Object]
 */
export const handleOrganizationSettingsFetch = () => dispatch =>
  Promise.resolve(dispatch(actions.fetchOrganizationSettingsRequest()))
    .then(ApikoApi.fetchOrganizationSettings)
    .then(response => dispatch(actions.fetchOrganizationSettingsSuccess(response)))
    .catch(error => dispatch(actions.fetchOrganizationSettingsFailure(error)));

/**
 * handleRequestSourceCreate :: Object -> Func -> Promise Error _
 */
export const handleRequestSourceCreate = data => dispatch =>
  Promise.resolve(dispatch(actions.createRequestSourceRequest()))
    .then(() => ApikoApi.createRequestSource(data))
    .then((requestSource) => {
      message.success('Request\'s Source successfully created.');
      dispatch(actions.createRequestSourceSuccess(requestSource));
    })
    .catch((error) => {
      dispatch(actions.createRequestSourceFailure());
      message.error(`Failed to create Request's Source: ${getResErrorMsg(error)}.`);
      return Promise.reject(error);
    });

/**
 * handleRequestSourceUpdate :: (ID, Object) -> Func -> Promise Error _
 */
export const handleRequestSourceUpdate = (requestSourceId, data) => dispatch =>
  Promise.resolve(dispatch(actions.updateRequestSourceRequest()))
    .then(() => ApikoApi.updateRequestSourceById(requestSourceId, data))
    .then((requestSource) => {
      message.success('Request\'s Source successfully updated.');
      dispatch(actions.updateRequestSourceSuccess(requestSource));
    })
    .catch((error) => {
      dispatch(actions.updateRequestSourceFailure());
      message.error(`Failed to update Request's Source: ${getResErrorMsg(error)}.`);
      return Promise.reject(error);
    });

/**
 * handleRequestSourceDelete :: ID -> Func -> Promise Error _
 */
export const handleRequestSourceDelete = requestSourceId => dispatch =>
  Promise.resolve(dispatch(actions.deleteRequestSourceRequest()))
    .then(() => ApikoApi.deleteRequestSourceById(requestSourceId))
    .then((requestSource) => {
      message.success('Request\'s Source successfully removed.');
      dispatch(actions.deleteRequestSourceSuccess(requestSource));
    })
    .catch((error) => {
      dispatch(actions.deleteRequestSourceFailure());
      message.error(`Failed to remove Request's Source: ${getResErrorMsg(error)}.`);
      return Promise.reject(error);
    });

/**
 * handleRequestStatusCreate :: Object -> Func -> Promise Error _
 */
export const handleRequestStatusCreate = data => dispatch =>
  Promise.resolve(dispatch(actions.createRequestStatusRequest()))
    .then(() => ApikoApi.createRequestStatus(data))
    .then((requestStatus) => {
      message.success('Request\'s Status successfully created.');
      dispatch(actions.createRequestStatusSuccess(requestStatus));
    })
    .catch((error) => {
      dispatch(actions.createRequestStatusFailure());
      message.error(`Failed to create Request's Status: ${getResErrorMsg(error)}.`);
      return Promise.reject(error);
    });

/**
 * handleRequestStatusUpdate :: (ID, Object) -> Func -> Promise Error _
 */
export const handleRequestStatusUpdate = (requestStatusId, data) => dispatch =>
  Promise.resolve(dispatch(actions.updateRequestStatusRequest()))
    .then(() => ApikoApi.updateRequestStatusById(requestStatusId, data))
    .then((requestStatus) => {
      message.success('Request\'s Status successfully updated.');
      dispatch(actions.updateRequestStatusSuccess(requestStatus));
    })
    .catch((error) => {
      dispatch(actions.updateRequestStatusFailure());
      message.error(`Failed to update Request's Status: ${getResErrorMsg(error)}.`);
      return Promise.reject(error);
    });

/**
 * handleRequestStatusDelete :: ID -> Func -> Promise Error _
 */
export const handleRequestStatusDelete = requestStatusId => dispatch =>
  Promise.resolve(dispatch(actions.deleteRequestStatusRequest()))
    .then(() => ApikoApi.deleteRequestStatusById(requestStatusId))
    .then((requestStatus) => {
      message.success('Request\'s Status successfully removed.');
      dispatch(actions.deleteRequestStatusSuccess(requestStatus));
    })
    .catch((error) => {
      dispatch(actions.deleteRequestStatusFailure());
      message.error(`Failed to remove Request's Status: ${getResErrorMsg(error)}.`);
      return Promise.reject(error);
    });

/**
 * handleRequestLabelCreate :: Object -> Func -> Promise Error _
 */
export const handleRequestLabelCreate = data => dispatch =>
  Promise.resolve(dispatch(actions.createRequestLabelRequest()))
    .then(() => ApikoApi.createRequestLabel(data))
    .then((requestLabel) => {
      message.success('Request\'s Label successfully created.');
      dispatch(actions.createRequestLabelSuccess(requestLabel));
    })
    .catch((error) => {
      dispatch(actions.createRequestLabelFailure());
      message.error(`Failed to create Request's Label: ${getResErrorMsg(error)}.`);
      return Promise.reject(error);
    });

/**
 * handleRequestLabelUpdate :: (ID, Object) -> Func -> Promise Error _
 */
export const handleRequestLabelUpdate = (requestLabelId, data) => dispatch =>
  Promise.resolve(dispatch(actions.updateRequestLabelRequest()))
    .then(() => ApikoApi.updateRequestLabelById(requestLabelId, data))
    .then((requestLabel) => {
      message.success('Request\'s Label successfully updated.');
      dispatch(actions.updateRequestLabelSuccess(requestLabel));
    })
    .catch((error) => {
      dispatch(actions.updateRequestLabelFailure());
      message.error(`Failed to update Request's Label: ${getResErrorMsg(error)}.`);
      return Promise.reject(error);
    });

/**
 * handleRequestLabelDelete :: ID -> Func -> Promise Error _
 */
export const handleRequestLabelDelete = requestLabelId => dispatch =>
  Promise.resolve(dispatch(actions.deleteRequestLabelRequest()))
    .then(() => ApikoApi.deleteRequestLabelById(requestLabelId))
    .then((requestLabel) => {
      message.success('Request\'s Label successfully removed.');
      dispatch(actions.deleteRequestLabelSuccess(requestLabel));
    })
    .catch((error) => {
      dispatch(actions.deleteRequestLabelFailure());
      message.error(`Failed to remove Request's Label: ${getResErrorMsg(error)}.`);
      return Promise.reject(error);
    });



// WEBPACK FOOTER //
// ./src/redux/thunk/organization-settings.js